<template>
  <div>
    <template>
      <v-form ref="form" lazy-validation>
        <v-col flat color="white" class="mt-1" cols="12" sm="3">
          <v-select
            class="mr-3 pt-4"
            :items="selectItems"
            inputmode="tel"
            item-value="setting_group"
            item-text="setting_group_name"
            v-model="selectItem"
            label="設定種別"
            @input="getSystemMaster"
          ></v-select>
          <v-spacer></v-spacer>
        </v-col>
      </v-form>
    </template>
    <v-data-table
      :headers="headers"
      :items="desserts"
      hide-default-footer
      class="col-12"
      disable-pagination
    >
      <template v-slot:[`item.setting_value`]="{ item }">
        <v-text-field v-model="item.setting_value"/>
      </template>
    </v-data-table>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn :disabled="btn[1].isActive" color="green darken-4" text @click="onRegist()">登録</v-btn>
    </v-card-actions>
    <ChangeOverlay
      page-name="システム管理"
      @processing="updateSystemMaster"
      @cancel="closeChangeOverLay"
      :process-result="process"
      :OverlaySwitch="changeOverlay"
    />
  </div>
</template>

<script>
import { authorityMixin } from '@/views/authorityMixin';
import ChangeOverlay from '@/views/Master/page/overlay/ChangeOverlay';
import { GET_SYSTEM_MASTER, UPDATE_SYSTEM_MASTER, GET_SETTING_GROUP_LIST } from '@/constants/system_master';
import validater from '../../../lib/validater';

export default {
    components: {
        ChangeOverlay
    },
    mixins: [
        authorityMixin
    ],
    data () {
        return {
            selectItems: [],
            selectItem: '',
            desserts: [],
            admin: {
                user_id: '',
                user_div: '',
                golf_code: ''
            },
            // v-data-tableのヘッダー
            headers: [
                { text: '設定名', value: 'setting_name', sortable: false, align: 'left', width: 400 },
                { text: '設定値', value: 'setting_value', sortable: false, align: 'center', width: 200 },
                { text: '', value: 'setting_unit', sortable: false, align: 'left', width: 100 },
                { text: '', value: 'dummy', sortable: false, align: 'center' }
            ],
            // ボタンの活性・非活性（authorityMixinを使用する場合は必須）
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '追加', isActive: true }
            ],
            changeOverlay: false,
            processing: false,
            // 処理結果
            process: {
                result: '',
                resultText: ''
            },
            vue_id: 'SCR0101'
        };
    },
    created () {
        this.Initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async Initialize () {
            this.$store.commit('loading/setIsLoading', true);

            this.admin = await this.getLoginAdmin();
            await this.getAuthorityList();

            // 設定グループ取得
            this.getSettingGroupList();
        },

        /* --------------------------------------------
        * 設定グループ取得
        * -------------------------------------------- */
        getSettingGroupList: async function () {
            try {
                let res = await this.$apollo.query({
                    query: GET_SETTING_GROUP_LIST,
                    variables: {
                        settingType: 2
                    }
                });
                this.selectItems = res.data.GetSettingGroupList.SettingGroupLists;
                this.selectItem = res.data.GetSettingGroupList.SettingGroupLists[0].setting_group;
                this.getSystemMaster();
            } catch (error) {
                this.error = error;
                this.$store.commit('loading/setIsLoading', false);
            }
        },
        /** --------------------------------------------
        * 設定値を取得
        * -------------------------------------------- */
        async getSystemMaster () {
            this.$store.commit('loading/setIsLoading', true);
            try {
                this.$apollo.query({
                    query: GET_SYSTEM_MASTER,
                    fetchPolicy: 'no-cache',
                    variables: {
                        settingGroup: this.selectItem
                    }
                }).then(res => {
                    this.desserts = res.data.GetSystemMaster.SystemMasterLists;
                    this.$store.commit('loading/setIsLoading', false);
                });
            } catch (error) {
                this.resultText = error;
                this.$store.commit('loading/setIsLoading', false);
            }
        },
        /** ----------------------------------------------
         * 変更ダイアログを閉じる
         * ---------------------------------------------- */
        closeChangeOverLay () {
            this.process.result = '';
            this.changeOverlay = false;
        },
        /** --------------------------------------------
        * コース一覧を取得
        * -------------------------------------------- */
        onRegist () {
            var updateData = [];
            for (var i = 0; i < this.desserts.length; i++) {
                // PUSH通知保存期間に数値以外が入力された場合
                if (this.desserts[i].setting_key === 'save_push') {
                    if (validater.checkIntType(this.desserts[i].setting_value) === false) {
                        this.desserts[i].setting_value = '';
                    }
                }
                let updateRec = {
                    setting_group: this.desserts[i].setting_group,
                    setting_key: this.desserts[i].setting_key,
                    setting_value: this.desserts[i].setting_value,
                    setting_code: this.desserts[i].setting_code,
                    setting_name: this.desserts[i].setting_name
                };
                updateData.push(updateRec);
            }

            this.updateSystemMaster(updateData);
        },
        /** --------------------------------------------
        * コース一覧を取得
        * -------------------------------------------- */
        updateSystemMaster: function (updateData) {
            this.processing = true;
            // システムマスタ更新
            this.$apollo.mutate({
                mutation: UPDATE_SYSTEM_MASTER,
                variables: {
                    UpdateSystemMasterList: updateData
                }
            }).then(res => {
                this.process.result = res.data.UpdateSystemMaster.result;
                if (res.data.UpdateSystemMaster.result === 0) {
                    this.process.resultText = res.data.UpdateSystemMaster.error_message;
                    this.changeOverlay = true;
                    this.processing = false;
                } else if (res.data.UpdateSystemMaster.result === 1) {
                    this.process.resultText = this.$t('result.success.change');
                    this.changeOverlay = true;
                    this.processing = false;
                }
            }).catch(error => {
                this.error = error;
                this.process.resultText = this.$t('result.error.change');
                this.changeOverlay = true;
                this.processing = false;
            });
        }
    }
};
</script>

<style scoped>
.v-data-table{
    overflow-y: scroll;
    min-height: 200px;
    max-height: 600px;
}

</style>
